import { Transaction, Currency, DataStream, TransactionReason } from '../../interfaces';

export interface TransactionLogDto {
  request: string;
  response: string;
  transactionId: string;
  createdWhen: string;
  stepNumber: number;
  totalSteps: number;
}

export enum TransactionTypes {
  GET_TRANSACTIONS_REQUEST = '@@transaction/GET_TRANSACTIONS_REQUEST',
  GET_TRANSACTIONS_SUCCESS = '@@transaction/GET_TRANSACTIONS_SUCCESS',
  GET_TRANSACTIONS_FAILURE = '@@transaction/GET_TRANSACTIONS_FAILURE',
  VIEW_TRANSACTIONS_OVERVIEW_REQUEST = '@@transaction/VIEW_TRANSACTIONS_OVERVIEW_REQUEST',
  VIEW_TRANSACTIONS_OVERVIEW_SUCCESS = '@@transaction/VIEW_TRANSACTIONS_OVERVIEW_SUCCESS',
  VIEW_TRANSACTIONS_OVERVIEW_FAILURE = '@@transaction/VIEW_TRANSACTIONS_OVERVIEW_FAILURE',
  GET_CURRENCIES = '@@transaction/GET_CURRENCIES',
  GET_CURRENCIES_SUCCESS = '@@transaction/GET_CURRENCIES_SUCCESS',
  GET_CURRENCIES_FAILURE = '@@transaction/GET_CURRENCIES_FAILURE',
  EXPORT_TRANSACTIONS_REQUEST = '@@transaction/EXPORT_TRANSACTIONS_REQUEST',
  EXPORT_TRANSACTIONS_SUCCESS = '@@transaction/EXPORT_TRANSACTIONS_SUCCESS',
  EXPORT_TRANSACTIONS_FAILURE = '@@transaction/EXPORT_TRANSACTIONS_FAILURE',
  EXPORT_VIEW_TRANSACTIONS_OVERVIEW_REQUEST = '@@transaction/EXPORT_VIEW_TRANSACTIONS_OVERVIEW_REQUEST',
  EXPORT_VIEW_TRANSACTIONS_OVERVIEW_SUCCESS = '@@transaction/EXPORT_VIEW_TRANSACTIONS_OVERVIEW_SUCCESS',
  EXPORT_VIEW_TRANSACTIONS_OVERVIEW_FAILURE = '@@transaction/EXPORT_VIEW_TRANSACTIONS_OVERVIEW_FAILURE',
  DOWNLOAD_RECEIPT_REQUEST = '@@transaction/DOWNLOAD_RECEIPT_REQUEST',
  DOWNLOAD_RECEIPT_SUCCESS = '@@transaction/DOWNLOAD_RECEIPT_SUCCESS',
  DOWNLOAD_RECEIPT_FAILURE = '@@transaction/DOWNLOAD_RECEIPT_FAILURE',
  GET_TRANSACTION_REASONS = '@@transaction/GET_TRANSACTION_REASONS',
  GET_TRANSACTION_REASONS_SUCCESS = '@@transaction/GET_TRANSACTION_REASONS_SUCCESS',
  GET_TRANSACTION_REASONS_FAILURE = '@@transaction/GET_TRANSACTION_REASONS_FAILURE',
  GET_TRANSACTION_LOGS_REQUEST = '@@transaction/GET_TRANSACTION_LOGS_REQUEST',
  GET_TRANSACTION_LOGS_SUCCESS = '@@transaction/GET_TRANSACTION_LOGS_SUCCESS',
  GET_TRANSACTION_LOGS_FAILURE = '@@transaction/GET_TRANSACTION_LOGS_FAILURE'
}

export type TransactionState = {
  readonly transactions: Transaction | null;
  readonly loading: boolean;
  readonly transactionError: any;
  readonly currencies: Currency[];
  readonly currenciesLoading: boolean;
  readonly currencyError: any;
  readonly isExporting: boolean;
  readonly isExportSuccess: boolean;
  readonly isExportError: boolean;
  readonly exportStream: DataStream | undefined;
  readonly transactionExportError: any;
  readonly isRequestingDownload: boolean;
  readonly downloadRecieptSuccess: boolean;
  readonly downloadRecieptError: boolean;
  readonly downloadReceiptStream: DataStream | undefined;
  readonly downloadError: any;
  readonly transactionsReasons: TransactionReason[] | [];
  readonly transactionLogs: TransactionLogDto[] | null;
  readonly transactionLogsLoading: boolean;
  readonly transactionLogsError: any;
};
